import { store } from '@store';
import { RightMenuProps } from '@components/RightMenu';
import { PageMode } from '@patient/ui/shared/store/RightMenu';

class EntryPageService {
    public setRightContent(params: RightMenuProps): void {
        store.app.setRightMenu({
            withoutMask: true,
            ...params,
        });
        store.entryPage.rightContentOpen = true;
    }

    public resetRightContent(): void {
        store.app.resetRightMenu();
        store.entryPage.rightContentOpen = false;
        store.entryPage.onClickOutsideRightContent = null;
        store.entryPage.pageMode = PageMode.EditNote;
    }
}

export const entryPageService = new EntryPageService();
